<template>
  <div class="add-one" :class="`add-one-${selectIndex+1}`" @click="selectAddOne">
    <svg-icon icon-class="add-oneyuan-sanjiao" class="triangle"></svg-icon>
    <div class="box">
      <svg-icon icon-class="add-oneyuan-bg" class="add-one-bg"/>
      <div class="add-one-select">
        <svg-icon v-if="selected" icon-class="add-oneyuan-select" class="add-one-selected"/>
      </div>
      <svg-icon icon-class="add-oneyuan-pointer" class="point" />
    </div>
  </div>
</template>
<script>
import addOneYuan from '@/mixins/addOneYuan';

export default {
  mixins: [addOneYuan],
}
</script>
<style lang="scss" scoped>
.add-one {
  width: 530px;
  height: 64px;
  position: relative;
  margin: 5px auto 0;
  display: flex;
  align-items: flex-end;
  .triangle {
    position: absolute;
    top: 2px;
    left: 68px;
    width: 30px;
    height: 12px;
  }

  &.add-one-2 {
    .triangle {
      left: 250px;
    }
  }
  &.add-one-3 {
    .triangle {
      left: 432px;
    }
  }
  .box {
    width: 100%;
    height: 52px!important;
    position: relative;
  }
  .add-one-bg {
    width: 100%;
    height: 52px!important;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .add-one-selected {
    position: absolute;
    left: 12px;
    top: 12px;
    width: 38px;
    height: 28px;
  }
}
.point{
  position: absolute;
  left: 70px;
  top: 13px;
  width: 91px;
  height: 27px;
  animation: shakeX 2.5s linear 0s infinite normal;
  animation-fill-mode: both;
}
@keyframes shakeX {

  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}
</style>
